import whiteLogoIcon from "../../assets/img/white-logo.svg";
import "./styles.css";

const Header = () => {
  const renderLogo = () => {
    return <img alt="white-logo" src={whiteLogoIcon} />;
  };

  return <div className="header">{renderLogo()}</div>;
};

export default Header;
